import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    signal,
    SimpleChanges
} from '@angular/core';
import { SectionSelectedState } from '@app/shared/components';
import { ISelectableSize } from './size-list.component.type';

@Component({
    selector: 'size-list',
    templateUrl: './size-list.component.html',
    styleUrls: ['./size-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SizeListComponent implements OnChanges {
    @Input({ required: true }) sizes: ISelectableSize[];
    @Input() label: string;
    @Input() type: string;
    @Input() stickyHeight?: number;

    @Output() sizesChanged = new EventEmitter<ISelectableSize[]>();
    @Output() sizeSelected = new EventEmitter<ISelectableSize>();

    selectedState = signal(SectionSelectedState.Unselected);
    selectedSizes = 0;

    ngOnChanges(changes: SimpleChanges): void {
        if ('sizes' in changes) {
            this.checkSelectedState();
        }
    }

    toggleSize(size: ISelectableSize): void {
        size.selected = !size.selected;
        this.checkSelectedState();
        this.sizeSelected.emit(size);
        this.emitSelectedSizes();
    }

    toggleAllSizes(state: boolean): void {
        this.sizes.forEach(size => (size.selected = state));
        this.checkSelectedState();
        this.emitSelectedSizes();
    }

    private checkSelectedState(): void {
        this.selectedSizes = this.sizes.filter(version => version.selected).length;

        switch (this.selectedSizes) {
            case 0:
                this.updateSelectedState(SectionSelectedState.Unselected);
                break;
            case this.sizes.length:
                this.updateSelectedState(SectionSelectedState.AllSelected);
                break;
            default:
                this.updateSelectedState(SectionSelectedState.SomeSelected);
                break;
        }
    }

    private updateSelectedState(state: SectionSelectedState): void {
        this.selectedState.set(state);
    }

    private emitSelectedSizes(): void {
        this.sizesChanged.emit(this.sizes.filter(size => size.selected));
    }
}
